
export default {
    name: "HappyKidsSubcatgoryButton",
    props: {
        data: {
            type: Object,
            default: () => ({
                text: 'TEXT TEXT',
                link: '/happy-kids/2023/before-birth',
                icon: 'cross',
                isActive: false,
                target: '_self',
            })
        }
    },
    data() {
        return {
            windowWidth: 0,
            isMobile: false,
        }
    },
    computed: {
        iconSrc() {
            if (this.data.isActive) {
                return require(`~/assets/images/family/icon/${this.data?.icon}.png`);
            } else {
                return require(`~/assets/images/family/icon/${this.data?.icon}-filled.png`);
            }
        },
        link() {
            if (this.$route.query.category) {
                return '/happy-kids-2024' + '/' + this.$route.params.any + '/' + '?' + 'category=' + this.data.slug;
            } else {
                return '/happy-kids/' + this.$route.params.year + '/' + this. $route.params.productCat + '/' + this.$route.params.productSubCat + '/' + this.data.slug
            }
        }
    },
    watch: {
        windowWidth(newValue) {
            if (newValue <= '768') {
                this.isMobile = true;
            }
        }
    },
    methods: {
        clickToNavigate() {
            console.log('router')
            this.$router.push({
                query: { category: this.data.slug },
                hash: this.$route.hash
            })
        }
    }
}
